import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class LandsApi extends ApiModule {
	constructor() {
		super(ModulesMap.LANDS, {
			entity: 'lands',
		})
	}
}
